import { pattern } from './pattern';

export const hourlyRateValidator = (value) => {
    if (!value || value === '') return false;

    // Check if it's a valid positive number
    const numValue = parseFloat(value);
    if (isNaN(numValue) || numValue <= 0) return false;

    // Check pattern for decimal format
    return pattern.hourlyRate.test(value.toString());
};
